var React = require('react');

function Wave (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10007.5 283.585C9231.16 -230.015 8472.28 69.5851 8189.88 283.585L8189.7 283.585C7907.3 497.585 7148.42 797.185 6372.11 283.585L6371.35 283.585C5595.04 -230.015 4836.16 69.5853 4553.76 283.585L4552.44 283.585C4270.04 497.585 3511.16 797.185 2734.85 283.585L2734.1 283.585C1957.79 -230.015 1198.91 69.5853 916.509 283.585L917.264 283.585C748.712 411.312 410.424 569.532 0 567.144V1318.5H10935V567.076C10651.1 570.178 10331.2 497.252 10008.2 283.585L10007.5 283.585Z","fill":"#3C5DFF"}));
}

Wave.defaultProps = {"width":"10935","height":"1319","viewBox":"0 0 10935 1319","fill":"none"};

module.exports = Wave;

Wave.default = Wave;
